export const environment = {
    production: false,
    apiUrl: 'https://mwapi-stage.greekspot.ch',//'http://localhost:8080',
    apiKey: '6LcnzbQoAAAAAA7cjDXm3Fcs6LAFymaJelr3PQcD'
};
